// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * App shell branding — ~60% red, ~30% purple accent, ~10% blue in content icons.
 * Used for headers, sidebars, login, and footers.
 */

.brand-app-header {
  background: linear-gradient(
    90deg,
    var(--brand-red-dark) 0%,
    var(--brand-red) 22%,
    var(--brand-red) 52%,
    var(--brand-red-light) 65%,
    var(--brand-purple-accent) 80%,
    var(--brand-purple-deep) 100%
  );
}

.brand-app-header-border {
  border-color: var(--brand-red-dark) !important;
}

.brand-app-sidebar {
  background: linear-gradient(
    180deg,
    var(--brand-red-dark) 0%,
    var(--brand-red) 32%,
    var(--brand-red) 58%,
    var(--brand-red-light) 70%,
    var(--brand-purple-accent) 86%,
    var(--brand-purple-deep) 100%
  );
  border-color: rgba(179, 32, 37, 0.35) !important;
}

.brand-app-sidebar-scroll {
  scrollbar-color: var(--brand-red-light) var(--brand-red-dark);
}

.brand-app-login-page {
  background: linear-gradient(
    135deg,
    var(--brand-red-dark) 0%,
    var(--brand-red) 38%,
    var(--brand-red) 55%,
    var(--brand-purple-accent) 78%,
    var(--brand-purple-deep) 100%
  );
}

.brand-app-login-content {
  background: linear-gradient(
    180deg,
    rgba(143, 26, 30, 0.12) 0%,
    rgba(179, 32, 37, 0.06) 100%
  );
}

.brand-app-login-btn {
  background: linear-gradient(
    90deg,
    var(--brand-red-dark) 0%,
    var(--brand-red) 50%,
    var(--brand-red-light) 72%,
    var(--brand-purple-accent) 100%
  ) !important;
  border: none !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(179, 32, 37, 0.35) !important;
}

.brand-app-login-btn:hover:not(:disabled),
.brand-app-login-btn:focus:not(:disabled) {
  box-shadow: 0 4px 12px rgba(179, 32, 37, 0.45) !important;
  filter: brightness(1.05);
}

.brand-app-login-btn:disabled {
  opacity: 0.75;
}

.brand-app-footer {
  background-color: #ffffff;
  border-top: 3px solid var(--brand-red) !important;
}

.brand-app-footer-title {
  color: var(--brand-red) !important;
}

.brand-app-footer-link:hover {
  color: var(--brand-red) !important;
}

.brand-app-notification-header {
  background: linear-gradient(
    90deg,
    var(--brand-red-dark) 0%,
    var(--brand-red) 35%,
    var(--brand-red-light) 58%,
    var(--brand-purple-accent) 82%,
    var(--brand-purple-deep) 100%
  );
}

.brand-app-modal-header {
  background: linear-gradient(
    90deg,
    var(--brand-red-dark) 0%,
    var(--brand-red) 45%,
    var(--brand-red-light) 68%,
    var(--brand-purple-accent) 100%
  ) !important;
  color: #ffffff !important;
  border: 0 !important;
}

.brand-focus-ring:focus {
  border-color: var(--brand-red) !important;
  box-shadow: 0 0 0 0.2rem rgba(179, 32, 37, 0.22) !important;
}

.brand-link-accent {
  color: var(--brand-purple-accent);
}

.brand-link-accent:hover {
  color: var(--brand-red);
}
`, "",{"version":3,"sources":["webpack://./src/styles/brand-shell.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE;;;;;;;;GAQC;AACH;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;;;;;;;;GAQC;EACD,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE;;;;;;;GAOC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;;;cAMY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;;EAEE,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;;;;;;;GAOC;AACH;;AAEA;EACE;;;;;;cAMY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/**\n * App shell branding — ~60% red, ~30% purple accent, ~10% blue in content icons.\n * Used for headers, sidebars, login, and footers.\n */\n\n.brand-app-header {\n  background: linear-gradient(\n    90deg,\n    var(--brand-red-dark) 0%,\n    var(--brand-red) 22%,\n    var(--brand-red) 52%,\n    var(--brand-red-light) 65%,\n    var(--brand-purple-accent) 80%,\n    var(--brand-purple-deep) 100%\n  );\n}\n\n.brand-app-header-border {\n  border-color: var(--brand-red-dark) !important;\n}\n\n.brand-app-sidebar {\n  background: linear-gradient(\n    180deg,\n    var(--brand-red-dark) 0%,\n    var(--brand-red) 32%,\n    var(--brand-red) 58%,\n    var(--brand-red-light) 70%,\n    var(--brand-purple-accent) 86%,\n    var(--brand-purple-deep) 100%\n  );\n  border-color: rgba(179, 32, 37, 0.35) !important;\n}\n\n.brand-app-sidebar-scroll {\n  scrollbar-color: var(--brand-red-light) var(--brand-red-dark);\n}\n\n.brand-app-login-page {\n  background: linear-gradient(\n    135deg,\n    var(--brand-red-dark) 0%,\n    var(--brand-red) 38%,\n    var(--brand-red) 55%,\n    var(--brand-purple-accent) 78%,\n    var(--brand-purple-deep) 100%\n  );\n}\n\n.brand-app-login-content {\n  background: linear-gradient(\n    180deg,\n    rgba(143, 26, 30, 0.12) 0%,\n    rgba(179, 32, 37, 0.06) 100%\n  );\n}\n\n.brand-app-login-btn {\n  background: linear-gradient(\n    90deg,\n    var(--brand-red-dark) 0%,\n    var(--brand-red) 50%,\n    var(--brand-red-light) 72%,\n    var(--brand-purple-accent) 100%\n  ) !important;\n  border: none !important;\n  color: #ffffff !important;\n  box-shadow: 0 2px 8px rgba(179, 32, 37, 0.35) !important;\n}\n\n.brand-app-login-btn:hover:not(:disabled),\n.brand-app-login-btn:focus:not(:disabled) {\n  box-shadow: 0 4px 12px rgba(179, 32, 37, 0.45) !important;\n  filter: brightness(1.05);\n}\n\n.brand-app-login-btn:disabled {\n  opacity: 0.75;\n}\n\n.brand-app-footer {\n  background-color: #ffffff;\n  border-top: 3px solid var(--brand-red) !important;\n}\n\n.brand-app-footer-title {\n  color: var(--brand-red) !important;\n}\n\n.brand-app-footer-link:hover {\n  color: var(--brand-red) !important;\n}\n\n.brand-app-notification-header {\n  background: linear-gradient(\n    90deg,\n    var(--brand-red-dark) 0%,\n    var(--brand-red) 35%,\n    var(--brand-red-light) 58%,\n    var(--brand-purple-accent) 82%,\n    var(--brand-purple-deep) 100%\n  );\n}\n\n.brand-app-modal-header {\n  background: linear-gradient(\n    90deg,\n    var(--brand-red-dark) 0%,\n    var(--brand-red) 45%,\n    var(--brand-red-light) 68%,\n    var(--brand-purple-accent) 100%\n  ) !important;\n  color: #ffffff !important;\n  border: 0 !important;\n}\n\n.brand-focus-ring:focus {\n  border-color: var(--brand-red) !important;\n  box-shadow: 0 0 0 0.2rem rgba(179, 32, 37, 0.22) !important;\n}\n\n.brand-link-accent {\n  color: var(--brand-purple-accent);\n}\n\n.brand-link-accent:hover {\n  color: var(--brand-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
